/**
 * Create custom select
 */
export default class CreateCustomSelect {
	/**
	 *
	 * @param select_input
	 * @param hideInput
	 */
	constructor(select_input, hideInput = true) {
		this.select_input =
			typeof select_input == "string"
				? document.querySelector(select_input)
				: select_input;


		// Check if there is select input, otherwise output warning
		if (!this.select_input) {
			console.warn("Cannot find select element: ", select_input);
			return;
		}

		// Hide real select input by default
		if (hideInput) {
			this.select_input.style.display = "none";
		}

		this.select_options = this.select_input.options;
		this.input_id = this.select_input.id || Date.now();
		this.arrow = `<span class="icon1">
								</span>`;
		this.CreateLayout();

		document.addEventListener("click", (e) => {
			// Get openned custom select if any
			const openned_select = document.querySelector(".custom-select.show");

			// Change select value if some of the options from custom select are clicked and close custom select
			if (
				e.target.closest(".custom-select__options .option") &&
				openned_select
			) {
				openned_select.classList.remove("show");
				this.ChangeValue(e.target.closest(".custom-select__options .option"));
				return;
			}

			// Close custom select when clicked anywhere except custom select's showing option, when it is pressed it should open the custom select
			if (!e.target.closest(".option--selected")) {
				openned_select && openned_select.classList.remove("show");
			}
		});

		// Change selected value in custom select when real select changes selected option
		this.select_input.addEventListener("change", () => {
			this.select_input.nextElementSibling.querySelector(
				".option--selected"
			).innerHTML =
				this.select_input.selectedOptions[0].textContent + this.arrow;

			// Need to use timeout to wait for select input change and then pickup it's values
			setTimeout(this.ResetSelectValues, 100, this.select_input);
		});
	}


	ChangeValue(selected_option) {
		// Get select input by name attribute from custom select's data-name attribute
		const select_input = document.querySelector(
				`[name="${selected_option.parentElement.dataset.name}"]`
			),
			// Create custom change event, because there is no normal event when changing input value with js
			event = document.createEvent("HTMLEvents");

		// Change selected value in real select
		select_input.querySelector(
			`[data-option_id="${selected_option.dataset.option_id}"]`
		).selected = true;

		// Emmit change event on real select input
		event.initEvent("change", true, false);
		select_input.dispatchEvent(event);
	}

	ResetSelectValues(input) {
		// Get all select inputs and loop through, change old values in custom select to new ones
		const custom_select = input.nextElementSibling,
			custom_select_option_container = custom_select.querySelector(
				".custom-select__options"
			);

		custom_select_option_container.innerHTML = CreateCustomSelect.CreateOptions(
			input.options
		);
	}

	// Create custom select layout
	CreateLayout() {
		let layout = `<div class="custom-select" id="select-${this.input_id}">
						<span class="option option--selected" data-togle="#select-${this.input_id}"><span class="icon1"></span>
                            ${this.select_input.selectedOptions[0].textContent}                                   
                        </span>
						<div id="options-${this.input_id}" class="custom-select__options" data-name="${this.select_input.name}">`;

		layout += CreateCustomSelect.CreateOptions(this.select_input.options);
		layout += "</div></div>";

		this.select_input.insertAdjacentHTML("afterend", layout);
	}

	// Compose options for custom select
	static CreateOptions(options) {
		let layout = "";

		Array.from(options).forEach((option, index) => {
			// Populate custom select with all option except the first which is label
			layout += `<span class="option ${option.className || ""}" id="${
				option.id || ""
			}" data-option_id=option_${index} data-value="${option.value}">${option.textContent}</span>`;
			option.dataset.option_id = `option_${index}`;
		});

		return layout;
	}
}

/**
 * Use only if you're not using woocommerce js for changing variation data
 * @constructor
 */
function GetVariationData(variation_output) {
	const variation_id_input = document.querySelector(".variation_id"),
		variation_select = document.querySelectorAll("#product-modal select"),
		form_el = document.querySelector("#product-modal form"),
		selected_options = Array.from(variation_select).map(
			(select) => select.selectedOptions[0].value
		);
	let variations = JSON.parse(form_el.dataset.product_variations);

	// Clean text from previous variation
	variation_output.innerHTML = "";
	variation_id_input.value = "";

	// Search variation only if all select inputs are selected
	if (selected_options.includes("")) return;

	// Filter variations based on select input's values
	selected_options.forEach((option) => {
		variations = variations.filter((variation) => {
			let attributes = Object.values(variation.attributes);
			return attributes.includes(option);
		});
	});

	// If there is no combination write message for no selected variation
	if (!variations.length) {
		variation_output.innerHTML = `
		<p>${variation_output.dataset.no_variation}</p>
		`;
		return;
	}

	// If there is variation, then get necessary information and print to user
	const { price_html, variation_id, sku, variation_description, image } =
		variations[0];

	variation_output.innerHTML = `
	<div class="woocommerce-variation-description">${variation_description}</div>
	<div class="woocommerce-variation-price">${price_html}</div>`;

	variation_output.classList.add("show");

	// Change variation id in hidden input
	variation_id_input.value = variation_id;
}
